export default "__VITE_ASSET__BfiY_ZZh__"